import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AnalyticsClick,
  SummaryAnalyticsEvent
} from '@com-delta-idp/mnx-skymiles-shared';
import { ErrorMessage, ModalService } from '@com-delta-omnichannel/aura';
import { AnalyticsEvent } from '../../models/analytics-event.interface';
import { OverviewPage } from './models/overview-page.interfaces';

@Component({
  selector: 'idp-overview-page',
  templateUrl: './overview-page.component.html',
  styleUrls: ['./overview-page.component.scss']
})
export class OverviewPageComponent {
  @Input() content: OverviewPage = {} as OverviewPage;
  @Output() clickAnalyticsEvent = new EventEmitter<AnalyticsClick>();
  @Output() openLink = new EventEmitter<string>();
  @Output() viewBenefitsAction = new EventEmitter<string>();
  @Output() analyticsEvent = new EventEmitter<SummaryAnalyticsEvent>();
  @Output() bannerClickEvent = new EventEmitter<AnalyticsEvent>();
  showModal = false;

  constructor(public modalService: ModalService) {}

  getFullError(error: ErrorMessage | undefined) {
    return error
      ? ({
          ...error,
          container: { height: 'full' }
        } as ErrorMessage)
      : undefined;
  }

  opened(value: boolean) {
    if (value) {
      this.modalService.overlayRef.updateSize({
        width: window.innerWidth <= 768 ? '90%' : '80%'
      });
    }
  }

  redirect(link: string) {
    this.openLink.emit(link);
  }

  onAnalyticsEvent(event: SummaryAnalyticsEvent): void {
    this.analyticsEvent.emit(event);
  }

  onTrackerAction(): void {
    this.showModal = !this.showModal;
    this.onAnalyticsEvent({
      action: {
        label: this.content.tracker.action.link.label,
        url: this.content.tracker.action.link.label + 'click'
      },
      event: 'click',
      eventType: 'click',
      type: 'link',
      pageSection: 'modal: Earning Medallion Status'
    });
    this.onAnalyticsEvent({
      action: {
        label: this.content.tracker.action.link.label,
        url: 'modal_open'
      },
      event: 'modal load',
      eventType: `skymiles overview - ${this.content.tracker.action.link.label} impression`,
      type: 'modal'
    });
  }

  dismissModal() {
    this.showModal = false;
    this.onAnalyticsEvent({
      action: {
        label: 'close',
        url: 'modal close'
      },
      event: 'click',
      eventType: 'modal link click',
      type: 'link',
      pageSection: 'modal: Earning Medallion Status'
    });
  }
}
